import productsActions from "actions/products";
import { CloseableContent, USER_PERMISSIONS, PRODUCT_PERMISSIONS } from "dyl-components";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { Button, Dropdown, Header, Icon, Popup, Ref } from "semantic-ui-react";
import AddProductCategory from "shared/AddProductCategory";
import { useBlocker } from "shared/confirmation/UseBlocker";
import FullScreenModalPopUp from "shared/FullScreenModalPopUp";
import RestrictedView from "shared/RestrictedView";

const Toolbar = ({ isReadingProductCatalogLimits }) => {

    const hasSelectedProducts = false;

    const onOpenBulkActionsModal = () => {};

    const addCategoryFormRef = useRef();

    const [isAddCategoryFormOpen, setIsAddCategoryFormOpen] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [pendingNavigation, setPendingNavigation] = useState(null);
    
    const [isDirty, setIsDirty] = useState(false);
    

    const dispatch = useDispatch();
    const [params] = useSearchParams();

    const refresh = () => {
        dispatch(productsActions.readProducts(Object.fromEntries(params)));
    };
    const handleConfirmLeave = () => {
        setIsConfirmationOpen(false);
        if (pendingNavigation) {
            pendingNavigation.retry();
        }
    };
    const onCloseAddCategoryForm = () => {
        setIsAddCategoryFormOpen(false);
    };
    
    useBlocker(
        (tx) => {
            if (isDirty && !isConfirmationOpen) {
                setPendingNavigation(tx);
                setIsConfirmationOpen(true);
            } else {
                tx.retry();
            }
        },
        isDirty
    );
    return (
        <>
            <Ref innerRef={addCategoryFormRef}>
                <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PRODUCT_CATALOG_ADD}>
                <Dropdown
                    as={Button}
                    floated="right"
                    floating
                    pointing="top left"
                    disabled={isReadingProductCatalogLimits}
                    color="primary"
                    text={
                        <span>
                            <Icon className="fas fa-plus" /> New
                            Category/Product
                        </span>
                    }
                    className="AddCategoryProductButton"
                    selectOnBlur={false}
                    value={null}
                >
                    <Dropdown.Menu>
                        <RestrictedView type='disabled' productPermission={PRODUCT_PERMISSIONS.SETTINGS_PRODUCT_CATALOG} modifiers={USER_PERMISSIONS.PRODUCT_CATALOG_CATEGORY_ADD}>
                            <Dropdown.Item
                                key="New Category"
                                onClick={() => setIsAddCategoryFormOpen(true)}
                            >
                                <span>
                                    <Icon className="fas fa-folder-plus" /> New Category
                                </span>
                            </Dropdown.Item>
                        </RestrictedView>
                        <RestrictedView type='disabled' productPermission={PRODUCT_PERMISSIONS.SETTINGS_PRODUCT_CATALOG} modifiers={USER_PERMISSIONS.PRODUCT_CATALOG_PRODUCTS_ADD}>
                            <Dropdown.Item
                                key="New Product"
                                as={Link}
                                to="/settings/product-catalog-quotes-invoices/create"
                            >
                                <span>
                                    <Icon className="fas fa-box" /> New Product
                                </span>
                            </Dropdown.Item>
                        </RestrictedView>
                    </Dropdown.Menu>
                </Dropdown>
                </RestrictedView>
            </Ref>
            <Popup
                context={addCategoryFormRef}
                open={isAddCategoryFormOpen}
                onClose={() => {
                    !isDirty && onCloseAddCategoryForm()
                }}
                closeOnDocumentClick={false}
                content={
                    <CloseableContent onClose={() => {
                        isDirty
                            ? setIsConfirmationOpen(true)
                            : onCloseAddCategoryForm();
                    }}>
                        <div style={{ padding: "1em" }}>
                            <Header color="primary">Create Category</Header>
                            <AddProductCategory refresh={refresh} onClose={onCloseAddCategoryForm} onDirtyChange={(dirty) => setIsDirty(dirty)}/>
                        </div>
                    </CloseableContent>
                }
                position="bottom left"
            />
            <FullScreenModalPopUp
                header={"Changes not saved"}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={() => {
                    onCloseAddCategoryForm();
                    setIsConfirmationOpen(false);
                    handleConfirmLeave()
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
            <Button
                floated="right"
                primary
                disabled={!hasSelectedProducts}
                onClick={onOpenBulkActionsModal}
            >
                Bulk Action
            </Button>
        </>
    );
};

export default Toolbar;
